import wcbtTomSelect from '../mixins/tom-select';
import wcbtDropDownPage from './mixins/wp-dropdown-page';
import wcbtMedia from '../mixins/media';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	wcbtTomSelect();
	wcbtDropDownPage();
	wcbtMedia();
} );
